import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mt-empty">
      <h2>404 — страница не найдена</h2>
      <p>
        <Link to="/">Вернуться на главную</Link>
      </p>
    </div>
  );
}
